var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSettingsAccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.447 3.833c0-1.288 1.095-2.333 2.446-2.333S8.34 2.545 8.34 3.833 7.244 6.167 5.893 6.167 3.447 5.122 3.447 3.833M11.66 3.833c0-1.288 1.095-2.333 2.447-2.333 1.35 0 2.446 1.045 2.446 2.333s-1.095 2.334-2.446 2.334-2.447-1.045-2.447-2.334M1.11 10.508c.478-2.1 2.438-3.675 4.783-3.675 2.703 0 4.893 2.09 4.893 4.667H2c-.552 0-1.012-.453-.89-.992M10.946 7.941a5 5 0 0 1 3.16-1.108c2.346 0 4.306 1.574 4.783 3.675.122.539-.337.992-.89.992h-5.815a5.78 5.78 0 0 0-1.238-3.559"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.5 15.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.502 12.69a.75.75 0 0 1 1.058.062l2 2.25a.75.75 0 0 1 0 .996l-2 2.25a.75.75 0 1 1-1.12-.996l1.556-1.752-1.557-1.752a.75.75 0 0 1 .063-1.058",
  clipRule: "evenodd"
})));
export default SvgIconSettingsAccess;